import { translationsList } from '../../sources';
import { normalizeLocale } from '../normalizeLocale';
export const getQueryLocale = () => {
    if (typeof window !== 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        const lang = searchParams.get('l') ?? searchParams.get('locale');
        if (lang && translationsList[normalizeLocale(lang)]) {
            return lang;
        }
    }
    return null;
};
//# sourceMappingURL=getQueryLocale.js.map